export const getReviewedShowroomMember = (response = {}) =>
  response.company || response.member;

export const isShowroomAdmin = (user) =>
  user && user.roles && user.roles.some((r) => r.title === 'admin');

export const getShowroomRolePrefix = (
  user,
  eligibility,
  fallbackRole = 'host'
) => {
  if (eligibility?.viewerRole === 'admin') return 'admin';
  if (eligibility?.viewerRole === 'host') return 'host';
  return isShowroomAdmin(user) ? 'admin' : fallbackRole;
};

export const getDeleteChatMessageRequestUrl = (
  user,
  eligibility,
  eventId,
  messageId
) => {
  const rolePrefix = getShowroomRolePrefix(user, eligibility);
  return `showroom/${rolePrefix}/events/${eventId}/chat/messages/${messageId}`;
};

export const getUpdateEventRequestUrl = (user, eligibility, eventId) => {
  const rolePrefix = getShowroomRolePrefix(user, eligibility);
  return `showroom/${rolePrefix}/events/${eventId}`;
};

export const getAccessRequestsRequestUrl = (user, eligibility, eventId) => {
  const rolePrefix = getShowroomRolePrefix(user, eligibility);
  if (!eventId || eventId === 'requests' || eventId === 'approvals') {
    return `showroom/${rolePrefix}/approvals`;
  }

  return `showroom/${rolePrefix}/events/${eventId}/approvals`;
};

export const getViewersRequestUrl = (user, eligibility, eventId) => {
  const rolePrefix = getShowroomRolePrefix(user, eligibility);

  if (!eventId || eventId === 'viewers') {
    return `showroom/${rolePrefix}/viewers`;
  }

  return `showroom/${rolePrefix}/events/${eventId}/viewers`;
};

export const getReviewAccessRequestUrl = (
  user,
  eligibility,
  eventId,
  accessRequestId
) => {
  const rolePrefix = getShowroomRolePrefix(user, eligibility);
  return `showroom/${rolePrefix}/events/${eventId}/approvals/${accessRequestId}`;
};
